export type Link = 'spec';
